import React, {Component} from 'react';
import {inject, observer} from "mobx-react/index";
import { IconeCarregar } from './Icones';

@inject("store")
@observer
export default class LoadingImage extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="loading-container">
                <IconeCarregar tamanho="2x"/>
            </div>

        );
            
    }
}


// WEBPACK FOOTER //
// ./src/modules/comum/components/LoadingImage.js